import React from "react";
import Heading from "../Hero/Heading"
import "../Hero/Hero.css";
import Navigation from "../Navigation/Navigation";


const Hero = () => {
  return (
    <div>
      <section className="hero" aria-label=" Julio César Mercado on Unsplash">
    
        <Navigation />
        <Heading />
        
      </section>
    </div>
  );
};

export default Hero;